// React
import * as React from "react";
import _ from 'lodash';
import { Divider } from 'rsuite';

// Internal components
import * as WidgetsThingsStructs from "../WidgetsThingsStructs";
import { IWidgetSettingsProps, WidgetDescriptionToPlegmaThing, IWidgetDescription } from '@UI/Widgets/WidgetStructs';
import { IWidgetDataValidateResp } from "@UI/Widgets/IWidgetDataValidateResp";
import { SettingsGroup, SettingsType } from '@Primitive/SettingsListType';
import { SettingsList } from '@Primitive/SettingsList';
import { isDefined, IsNullOrEmpty, getRandomSmallKey, IsNullOrWhiteSpace } from '@Utils/Micro';
import { WebThingPort, WebThing } from '@API/WebThing';
import { WebThingPortType } from '@API/WebNodeTypes';
import { Plegma } from '@API/Api';
import { WebNode } from '@API/WebNode';
import { IWidgetThingsClass } from "../Utils/IWidgetThingsClass";
import { IconTextButton, ButtonData } from '@Primitive/IconTextButton';
// =================================================================================================
const enum PortKeys {
    Data = "Data",
    SelectedIcon = "SelectedIcon"
}
// -------------------------------------------------------------------------------------------------
export interface GroupOfButtonGroupsData {
    title?: string;
    buttons?: ButtonData[];

    /** 
     * Group title styles
     */
    titleStyle?: React.CSSProperties;

    /**
     * Set style thew button itself
     */
    buttonStyle?: React.CSSProperties;

    /*
     *    Styling settings for icon.
     */
    buttonIconStyle?: React.CSSProperties;

    /*
    *    Styling settings for icon caption.
    */
    buttonCaptionStyle?: React.CSSProperties;

    showBubble?: boolean;
    bubbleBackgroundColor?: string;
    bubbleColor?: string;
    bubbleFontSize?: number;
    bubbleSize?: number

    /**
     * place labels below buttons
     */
    labelsBelowButtons?: boolean;
}
// -------------------------------------------------------------------------------------------------
export interface GroupOfButtonGroupsState {
    data: {
        groups: GroupOfButtonGroupsData[];
        styles: {
            /**
             * Options for limited grid
             */

            /**
             * Limit the number of columns
             */
            numberOfColumns?: number;

            /**
             * Fill the height/width of the group.
             * This is make sense when you have only one group and the title is empty
             */
            fillGroup?: boolean;

            /**
             * Widget styles
             */
            widgetStyle?: React.CSSProperties;

            /** 
             * Group title styles
             */
            groupTitleStyle?: React.CSSProperties;

            /**
             * Set style the button itself
             */
            buttonStyle?: React.CSSProperties;

            /*
             *    Styling settings for icon.
             */
            buttonIconStyle?: React.CSSProperties;

            /*
            *    Styling settings for icon caption.
            */
            buttonCaptionStyle?: React.CSSProperties;
        }
    };
}
// -------------------------------------------------------------------------------------------------
export class GroupOfButtonGroups extends React.Component<WidgetsThingsStructs.PartialIWidgetThingsProps<GroupOfButtonGroupsData>, GroupOfButtonGroupsState> {
    // ---------------------------------------------------------------------------------------------
    constructor(props: WidgetsThingsStructs.PartialIWidgetThingsProps<GroupOfButtonGroupsData>) {
        super(props);
        this.state = {
            data: {
                styles: {},
                groups: []
            }
        }
    }
    // ---------------------------------------------------------------------------------------------
    componentDidMount() {
        this.UpdateDataFromPort(this.props);
    }
    // --------------------------------------------------------------------------------------------
    componentDidUpdate(prevProps: WidgetsThingsStructs.PartialIWidgetThingsProps<GroupOfButtonGroupsData>) {
        if (prevProps.PortVersion != this.props.PortVersion)
            this.UpdateDataFromPort(this.props);
    }
    // --------------------------------------------------------------------------------------------
    onIconClick = (buttonInfo: ButtonData, groupIndex: any) => {
        this.props.SendPortEvent(PortKeys.SelectedIcon, { buttonID: buttonInfo.id, groupID: groupIndex })
    };
    // --------------------------------------------------------------------------------------------

    UpdateDataFromPort(props: WidgetsThingsStructs.PartialIWidgetThingsProps<GroupOfButtonGroupsData>) {
        if (!isDefined(this.props.PortsStates))
            return;

        let port = this.props.PortsStates[PortKeys.Data];
        if (!isDefined(port))
            return;


        let data: any = port.State; //todo interface Here
        if (!_.isEmpty(data)) {
            this.setState({
                data: data
            });

            // Stop the set here
            return;
        }

        //Default values needed here
        this.setState({
            data: {
                styles: {},
                groups: []
            }
        });
    }
    // ---------------------------------------------------------------------------------------------
    render() {
        const { data } = this.state;
        const { width, height } = this.props;
        let padding = 10;
        let ht = (data.groups?.length > 1) ? Math.floor(height / data.groups.length) : height;
        let bubbleStyle = {
            color: this.props.WidgetData.bubbleColor,
            backgroundColor: this.props.WidgetData.bubbleBackgroundColor,
            fontSize: this.props.WidgetData.bubbleFontSize,
            height: this.props.WidgetData.bubbleSize,
            width: this.props.WidgetData.bubbleSize
        }

        return (
            <div style={{ width: width, height: height, ...(data?.styles?.widgetStyle ?? {}) }}>
                {
                    _.map(data.groups, (group, groupIndex) => {
                        const { title, buttons } = group;

                        let groupWidth = width;
                        let TitleStyle = group?.titleStyle ?? data?.styles?.groupTitleStyle ?? {};
                        let style = { ...(group?.buttonStyle ?? {}), ...(data.styles?.buttonStyle ?? {}) };
                        let captionStyle = { ...(group?.buttonCaptionStyle ?? {}), ...(data.styles?.buttonCaptionStyle ?? {}) };
                        let iconStyle = { ...(group?.buttonIconStyle ?? {}), ...(data.styles?.buttonIconStyle ?? {}) };

                        if (data.styles?.numberOfColumns > 0) {
                            let numberOfColumn = data.styles?.numberOfColumns;
                            let margin = (data.styles?.buttonStyle?.margin as number) ?? 0;
                            let buttonWidth = Math.floor((width - 2 * numberOfColumn * margin) / numberOfColumn);

                            if (data.styles?.fillGroup == true) {
                                let numberRows = Math.ceil(group.buttons.length / numberOfColumn);
                                let buttonHeight = Math.floor((height - 2 * numberRows * margin) / numberRows);

                                style.width = Math.min(buttonWidth, buttonHeight);
                                style.height = style.width;
                            } else {
                                style.width = buttonWidth;
                            }

                            groupWidth = style.width * numberOfColumn + 2 * numberOfColumn * margin;
                        }


                        return <div key={`item-${title}-${groupIndex}`} style={{ width: groupWidth, minHeight: ht - 2 * padding, padding: 0, margin: 0, backgroundColor: 'inherit' }}>
                            {
                                IsNullOrWhiteSpace(title) ? null : <React.Fragment>
                                    {/**Title*/}
                                    <div style={{ marginLeft: '10px', ...TitleStyle }}>
                                        {title}
                                    </div>

                                    {/**Horizontal Line*/}
                                    <Divider style={{ margin: 0, padding: 0 }} />
                                </React.Fragment>
                            }

                            <div style={{ display: 'flex', flexDirection: 'row', flexFlow: "row wrap" }}>
                                {
                                    /**Map Nested Items icon & caption*/
                                    _.map(buttons, (nestedItem, i) => {
                                        /*Generate a unique random id for the nested Item when ins not defined*/
                                        nestedItem.id = !isDefined(nestedItem.id) ? "Icon-" + getRandomSmallKey() : nestedItem.id;
                                        return <IconTextButton
                                            showBubble={this.props.WidgetData.showBubble}
                                            bubbleStyle={bubbleStyle}
                                            bubbleContent={nestedItem.bubbleContent}
                                            button={nestedItem}
                                            style={style}
                                            captionStyle={captionStyle}
                                            iconStyle={iconStyle}
                                            index={i}
                                            groupIndex={groupIndex}
                                            onIconClick={this.onIconClick}
                                            labelBelowButton={this.props.WidgetData.labelsBelowButtons} />
                                    })
                                }
                            </div>
                        </div>

                    }) //map end
                }
            </div>
        );//outer return
    }
}
// =================================================================================================
class GroupOfButtonGroupsSettings extends React.PureComponent<IWidgetSettingsProps<GroupOfButtonGroupsData>> {
    constructor(props: IWidgetSettingsProps<GroupOfButtonGroupsData>) {
        super(props);
    }
    // ---------------------------------------------------------------------------------------------
    render() {
        let settings: SettingsGroup<GroupOfButtonGroupsData>[] = [
            {
                name: "",
                elements: [
                    {
                        type: SettingsType.Boolean,
                        label: 'Show Bubble',
                        dataPath: 'showBubble',
                        tooltip: 'If enabled, show the bubble indicator'
                    },
                    {
                        type: SettingsType.ColorPicker,
                        label: 'Bubble Text Color',
                        tooltip: 'Color for the bubble text',
                        dataPath: 'bubbleColor',
                        disable: !this.props.WidgetData.showBubble
                    },
                    {
                        type: SettingsType.ColorPicker,
                        label: 'Bubble Background Color',
                        tooltip: 'Color of bubble background',
                        dataPath: 'bubbleBackgroundColor',
                        disable: !this.props.WidgetData.showBubble
                    },
                    {
                        type: SettingsType.Slider,
                        label: 'Bubble Font size',
                        tooltip: 'Configure bubble font size.',
                        dataPath: 'bubbleFontSize',
                        minValue: 5,
                        maxValue: 20,
                        stepValue: 1,
                        valuePosfix: 'px',
                        disable: !this.props.WidgetData.showBubble
                    },
                    {
                        type: SettingsType.Slider,
                        label: 'Bubble size',
                        tooltip: 'Configure bubble size.',
                        dataPath: 'bubbleSize',
                        minValue: 5,
                        maxValue: 40,
                        stepValue: 1,
                        valuePosfix: 'px',
                        disable: !this.props.WidgetData.showBubble
                    },
                    {
                        type: SettingsType.Boolean,
                        label: 'Labels Below Buttons',
                        dataPath: 'labelsBelowButtons',
                        tooltip: 'When enabled, it places any labels below the buttons'
                    }
                ]
            }
        ];

        return <SettingsList
            AutoSave={true}
            SettingsMap={settings}
            Data={this.props.WidgetData}
            onSaveData={(data) => {
                if (isDefined(this.props.onWidgetDataUpdate))
                    this.props.onWidgetDataUpdate(data);
            }}
        />;
    }
}
// =================================================================================================

export class GroupOfButtonGroupsWidget extends IWidgetThingsClass<GroupOfButtonGroupsData> {
    Render(key: string, width: number, height: number): React.ReactNode {
        return <GroupOfButtonGroups />;
    }
    // ---------------------------------------------------------------------------------------------
    RenderWidgetSettings(key: string, width: number, height: number): React.ReactElement<any> {
        const parent = this.Parent;
        return <GroupOfButtonGroupsSettings
            key={'settings-' + key}
            width={width}
            height={height}
            WidgetData={_.cloneDeep(this.WidgetData)}
            WidgetDefaultValues={_.cloneDeep(this.Description.DefaultValues)}
            ThingKey={this.ThingKey}
            NodeKey={this.NodeKey}
            onWidgetDataUpdate={(d) => this.WidgetDataUpdate(d)}
            SettingListToolbar={isDefined(parent) ? parent.SettingsListToolbar : null}
        />;
    }
    // ---------------------------------------------------------------------------------------------
    private createThingPorts(widgetData: GroupOfButtonGroupsData): WebThingPort[] {
        let ports: WebThingPort[] = [];

        // TODO: Set the Ports
        ports.push(new WebThingPort(
            {
                Name: 'Data',
                PortKey: PortKeys.Data,
                Type: Plegma.ePortType.JsonString,
                ioDirection: Plegma.ioPortDirection.Input,
                ConfFlags: Plegma.ePortConf.None,
                Description: 'PortKeyDescription',
                State: ''
            },
            WebThingPortType.Data)
            //(data) => this.ValidateValues('PortKey', data)) //todo add input data validation
        );

        ports.push(new WebThingPort(
            {
                Name: "Selected Icon",
                PortKey: PortKeys.SelectedIcon,
                Type: Plegma.ePortType.JsonString,
                ioDirection: Plegma.ioPortDirection.Output,
                ConfFlags: Plegma.ePortConf.None,
                Description: 'The selected icon data',
                State: ""
            },
            WebThingPortType.Trigger
        ));
        return ports;
    }
    // ---------------------------------------------------------------------------------------------
    updateThing() {
        let widgetData = this.WidgetData,
            webNode = WebNode.GetInstanceKey(this.NodeKey),
            webThing = webNode.GetThing(this.ThingKey);

        webThing.Ports = {};

        // Add thing's ports.
        this
            .createThingPorts(widgetData)
            .forEach((port) => webThing.AddPort(port, false));

        // Update thing.
        webNode
            .GetModule(this.WebModuleKey)
            .UpdateThing(webThing);
    }
    // ---------------------------------------------------------------------------------------------
    initThing() {
        let widgetData = (this.WidgetData as GroupOfButtonGroupsData);

        // TOOD: Update thing description and widget icon

        // Create plegma thing.
        let plegmaThing = WidgetDescriptionToPlegmaThing(this.Description);

        // Create thing's ports and web thing.
        let ports = this.createThingPorts(widgetData);
        let webThing = new WebThing(this.WebModule, plegmaThing, ports);

        this.ThingKey = webThing.ThingKey;
    }
    // ---------------------------------------------------------------------------------------------
    public static GetDefaultWidgetDataStatic(): GroupOfButtonGroupsData {
        return {
            // TODO: Set the default values for the widget
            bubbleColor: 'white',
            showBubble: false,
            bubbleBackgroundColor: '#D0021B',
            bubbleSize: 16,
            bubbleFontSize: 12,
            labelsBelowButtons: false
        };
    }
    // ---------------------------------------------------------------------------------------------
    public GetDefaultWidgetData() { return GroupOfButtonGroupsWidget.GetDefaultWidgetDataStatic(); }
    // ---------------------------------------------------------------------------------------------
    public static GetWidgetDesc(): IWidgetDescription {
        // TODO: Update the widget Description
        return {
            Title: 'Group Of Buttons Groups',
            WidgetTitle: '',
            Key: 'GroupOfButtonGroupsWidget',
            Type: 'GroupOfButtonGroupsWidget',
            Data: GroupOfButtonGroupsWidget.GetDefaultWidgetDataStatic(),
            Description: 'GroupOfButtonGroups Description',
            MinH: 1,
            MinW: 1,
            ShowExtraMenu: false,
            IconURI: WidgetsThingsStructs.IconURIPath + '/svg/tile.svg' //todo Update Icon
        };
    }
    // ---------------------------------------------------------------------------------------------
    public GetLocalizationDictionary() {
        const res = {};
        // expose title if defined
        if (!IsNullOrEmpty(this.Description.WidgetTitle))
            res[WidgetsThingsStructs.WidgetLocalizationKeys.Title] = this.Description.WidgetTitle;

        return res;
    }
    // ---------------------------------------------------------------------------------------------
    public ValidateValues(key: string, value: any): IWidgetDataValidateResp {
        // todo: set schema validators
        return { valid: true, errors: "" };
    }
    // ---------------------------------------------------------------------------------------------
    public MigrateDefaultWidgetData(data: GroupOfButtonGroupsData): GroupOfButtonGroupsData {
        return data;
    }
    // ---------------------------------------------------------------------------------------------
    public GetDefaultValues() { return {} }
    // ---------------------------------------------------------------------------------------------
}